import { FIELD_VALUES } from '@funnels/constants';

export default function getGenderPronoun(gender?: string) {
  switch (gender) {
    case FIELD_VALUES.MALE:
      return 'his';
    case FIELD_VALUES.FEMALE:
      return 'her';
    default:
      return 'his/her';
  }
}
